import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './lib/index.js'
import resizeListener from './mixins/resizeListener'
import './theme/index.css'
import './assets/icons/iconfont.css'
import './assets/css/icon.css'
import './assets/css/main.css'
import './assets/css/rich-text.css'

import VueScroller from "vue-scroller"
Vue.use(VueScroller)
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
    mixins: [resizeListener]
}).$mount('#app');
